import { render, staticRenderFns } from "./ExpansionPanel.vue?vue&type=template&id=7bae70e8&scoped=true&"
import script from "./ExpansionPanel.vue?vue&type=script&lang=js&"
export * from "./ExpansionPanel.vue?vue&type=script&lang=js&"
import style0 from "./ExpansionPanel.vue?vue&type=style&index=0&id=7bae70e8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bae70e8",
  null
  
)

export default component.exports